export default {
  id: "manual-route",
  title: "Create a manual route",
  summary: "Set your own waypoints on the map and calculate the ETA",
  minutes: 4,
  interactive: [{ selector: ".leaflet-container" }],
  steps: [
    {
      title: "Create a manual route",
      text: "With a manual route you decide where the vessel goes. METEO TRACKER then calculates the ETA and checks the route against weather and risk zones.",
    },
    {
      anchor: "drawer-planner",
      skipIf: "planner-panel",
      click: true,
      title: "Open the Voyage Planner",
      text: "Click <b>Voyage Planner</b>.",
      side: "right",
    },
    {
      anchor: "planner-steps",
      skipIf: "planner-mode",
      until: "planner-mode",
      title: "Start at step 1",
      text: "Click <b>1 · Plan</b>.",
      side: "right",
    },
    {
      anchor: "planner-mode",
      title: "Choose Manual",
      text: "Select <b>Manual</b>.",
      side: "right",
    },
    {
      anchor: "planner-vessel",
      title: "Vessel",
      text: "Select the vessel.",
      side: "right",
    },
    {
      selector: ".leaflet-container",
      title: "Start and finish",
      text: "Click on the map to set the <b>start</b>, then click again to set the <b>finish</b>. You can also type ports or positions in the planner.",
      side: "over",
    },
    {
      selector: ".leaflet-container",
      title: "Add waypoints",
      text: "<ul><li><b>Click</b> on the map to add a waypoint. It is added to the nearest leg.</li><li><b>Drag</b> a waypoint to move it.</li><li><b>Click a waypoint</b> to open its card: choose great circle or rhumb line for the next leg, or delete the point.</li></ul>",
      side: "over",
    },
    {
      anchor: "planner-departure",
      title: "Departure time and speed",
      text: "Set the departure time (UTC) and the <b>base speed</b>, i.e. the speed in calm weather.",
      side: "right",
    },
    {
      anchor: "planner-restrictions",
      title: "Checks",
      text: "In manual mode the route is not changed. Instead METEO TRACKER <b>checks</b> it and warns you if it crosses ECA or risk zones.",
      side: "right",
    },
    {
      anchor: "planner-footer",
      click: "planner-primary",
      title: "Continue",
      text: "Click <b>Continue to Options</b>.",
      side: "top",
    },
    {
      anchor: "planner-footer",
      click: "planner-primary",
      title: "Calculate the ETA",
      text: "Check the vessel data if needed, then click <b>Calculate ETA</b>.",
      side: "top",
    },
    {
      anchor: "planner-panel",
      until: "planner-result",
      title: "Calculating …",
      text: "The ETA is being calculated. The tour continues automatically when the result is ready.<br><br>If the calculation fails, the panel explains why. Fix it and press <b>Calculate ETA</b> again. The tour waits for you.",
      side: "right",
    },
    {
      anchor: "planner-result",
      title: "The result",
      text: "ETA, duration, distance and the weather along your route. Coloured labels show warnings. You can go back to <b>1 · Plan</b> at any time to move waypoints and calculate again.",
      side: "right",
    },
    {
      anchor: "planner-primary",
      title: "Save",
      text: "The route is a <b>draft</b> until you save it. Click <b>Show in Fleet Explorer</b> and save it with the <b>⋮</b> menu.",
      side: "top",
    },
  ],
}
